import { ApMap } from '../../store/ApMap';
import { apiService } from '../APIService';

const API_SERVER_URL = process.env.REACT_APP_API_SERVER_URL;

export const createApMapData = (apMapData: ApMap) => {
  return apiService.callExternalApi<ApMap>({
    url: `${API_SERVER_URL}/ap-maps`,
    method: 'POST',
    headers: {
      'content-type': 'application/json'
    },
    data: apMapData
  });
};

export const deleteApMapData = (id: string) => {
  return apiService.callExternalApi<ApMap>({
    url: `${API_SERVER_URL}/ap-maps/${id}`,
    method: 'DELETE',
    headers: {
      'content-type': 'application/json'
    }
  });
};

export const updateApMapData = (apMapData: ApMap) => {
  return apiService.callExternalApi<ApMap>({
    url: `${API_SERVER_URL}/ap-maps/${apMapData.id}`,
    method: 'PUT',
    headers: {
      'content-type': 'application/json'
    },
    data: apMapData
  });
};

export const listApMaps = () => {
  return apiService.callExternalApi<{ apMaps: ApMap[] }>({
    url: `${API_SERVER_URL}/ap-maps`,
    method: 'GET',
    headers: {
      'content-type': 'application/json'
    }
  });
};
